import { IOrganizationState } from "../../../shared/interfaces/IOrganizationState";

export const InitialState:IOrganizationState={
    organizationData:[],
    isOrgPopUpOpen:false
}